import moment from 'moment';
import { DATE_FORMAT } from '@common/constants';
import { IBookingRouteApi } from '@common/interfaces';

export const sortBookingRoutes = (routes: IBookingRouteApi[]): void => {
  routes.sort((route1, route2) =>
    moment(`${route1.pickup_date} ${route1.pickup_time}`, DATE_FORMAT.DRIVE_DATE).isAfter(
      moment(`${route2.pickup_date} ${route2.pickup_time}`, DATE_FORMAT.DRIVE_DATE),
    )
      ? 1
      : -1,
  );
};
